import { getUserData, getVenueData } from "@ueni/users-api";
import { useCallback, useEffect } from "react";
import { useHistory } from "react-router";
import api from "../../../services/api";
import { getHubUrl } from "../../../utils/hubRoutes";

export const PassPage = () => {
  const history = useHistory();

  const redirectIfAuthorized = useCallback(async () => {
    try {
      const [userResponse, venueResponse] = await Promise.all([getUserData(api), getVenueData(api)]);

      const user = userResponse.data;
      const venue = venueResponse.data.results[0];

      const urlParams = new URLSearchParams(window.location.search);
      const redirectUrl = urlParams.get("url");
      if (redirectUrl) {
        const url = new URL(redirectUrl);
        url.searchParams.append("email", user.email);
        url.searchParams.append("user_guid", user.guid);
        url.searchParams.append("user_name", `${user.first_name || ""} ${user.last_name || ""}`.trim());
        url.searchParams.append("plan_code", user.plan_code);
        url.searchParams.append("primary_guid", venue.guid);
        window.location.assign(url.toString());
      } else {
        window.location.assign(`${getHubUrl(user.locale)}?logged_user=1`);
      }
    } catch (error) {
      const loginUrl = new URL(window.location.origin + "/login");
      loginUrl.searchParams.append("redirect_url", window.location.href);

      history.push(loginUrl.toString());
    }
  }, [history]);

  useEffect(() => {
    redirectIfAuthorized().then();
  }, []);

  return null;
};
